import { GetListRes } from "./GetListRes";

export enum TableColumnKey {
  Operation = "operation",
  BatchId = "batchId",
  MerchantName = "merchantName",
  ChainName = "chainName",
  SmartAccountType = "smartAccountType",
  FreeBandWidthOnly = "freeBandWidthOnly",
  SpenderContractVersion = "spenderContractVersion",
  SpenderAddress = "spenderAddress",
  RecipientOwnerAddress = "recipientOwnerAddress",
  RecipientAddress = "recipientAddress",
  RecipientWalletType = "recipientWalletType",
  Status = "status",
  CurrencyOfMinerFee = "currencyOfMinerFee",
  MinerFee = "minerFee",
  Currency = "currency",
  TotalAmount = "totalAmount",
  ActualAmount = "actualAmount",
  TotalCount = "totalCount",
  CreationTime = "creationTime",
  LastModifiedTime = "lastModifiedTime",
  ViewOperation = "viewOperation",
  ViewOperationTransaction = "viewOperationTransaction",
  ViewTronRentResourceRecords = "viewTronRentResourceRecords",
  CreatedBy = "createdBy",
}

export type TableRow = { [K in TableColumnKey]?: string } & {
  id: number;
  rawData?: GetListRes;
};
